import { Translations } from 'models/Translations';
import { Language } from 'models/ProfileSettings';

export const TranslationsActionType = {
    LOAD_TRANSLATIONS: "LOAD_TRANSLATIONS",
    LOAD_TRANSLATIONS_DONE: "LOAD_TRANSLATIONS_DONE",
};

interface ILoadTranslations {
    type: typeof TranslationsActionType.LOAD_TRANSLATIONS,
    translations: Translations,
    language: Language
}

export type ITranslationsActions = ILoadTranslations

// without a profile (logged out) the browser language decides; anything but German falls back to English
const browserLanguage = (): Language => navigator.language.toLowerCase().startsWith('de') ? 'DE' : 'EN';

export class TranslationsActions {
    public static loadTranslations(language: Language = browserLanguage()): TranslationsActions {
        return {
            type: TranslationsActionType.LOAD_TRANSLATIONS,
            translations: Translations.empty(),
            language: language
        }
    }
}

